module.exports = __webpack_public_path__ + "static/media/napolitano.7bb8c2bd.png";